__turbopack_context__.v({
  "column": "ApplyFormSocial-module__MFN6Na__column",
  "columns": "ApplyFormSocial-module__MFN6Na__columns",
  "container": "ApplyFormSocial-module__MFN6Na__container",
  "fadeInItems": "ApplyFormSocial-module__MFN6Na__fadeInItems",
  "field": "ApplyFormSocial-module__MFN6Na__field",
  "input": "ApplyFormSocial-module__MFN6Na__input",
  "spacing--lg": "ApplyFormSocial-module__MFN6Na__spacing--lg",
  "spacing--md": "ApplyFormSocial-module__MFN6Na__spacing--md",
  "spacing--sm": "ApplyFormSocial-module__MFN6Na__spacing--sm",
  "spacing--xl": "ApplyFormSocial-module__MFN6Na__spacing--xl",
  "spacing--xs": "ApplyFormSocial-module__MFN6Na__spacing--xs",
  "spacing--xxl": "ApplyFormSocial-module__MFN6Na__spacing--xxl",
  "spacing--xxs": "ApplyFormSocial-module__MFN6Na__spacing--xxs",
  "spacing--xxxl": "ApplyFormSocial-module__MFN6Na__spacing--xxxl",
  "spacing--xxxs": "ApplyFormSocial-module__MFN6Na__spacing--xxxs",
  "text": "ApplyFormSocial-module__MFN6Na__text",
  "title": "ApplyFormSocial-module__MFN6Na__title",
});
